export default __webpack_public_path__ + "static/media/petra.3e41a34e.jpg";